import React, { Component, createRef } from 'react';
import { message, Pagination, Modal } from 'antd';
import CpEmpty from '../../components/CpEmpty';
import { showNumber } from './statusConfig';
import send from '../../util/request';
import { inventoryReturnOrders } from './api';
import RenderList from './component/renderList';
import { SearchForm } from './component/searchForm';
import moment from 'moment';
import './style.less';
class OrderList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderList: [],
      formateList: [],
      currentStatus: undefined,
      emptyStatus: '',
      loading: true,
      paginationProps: {
        current: 1,
        pageSize: 10,
        total: 0,
        onChange: (current, pageSize) => this.pageChanged(current, pageSize)
      },
      messageInfo: {
        visible: false,
      },
      logisticsVisible: false,//物流详情弹框
      orderStatus: undefined,//订单编号
      logisticsData: []//物流数据
    };
    this.searchRef = createRef();
  }

  componentDidMount() {
    const params = { page: 1, page_size: 10 };
    this.requestOrderList(params);
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  searchFn = () => {
    const { paginationProps: { pageSize } } = this.state;
    this.requestOrderList({ page: 1, page_size: pageSize });
  }

  requestOrderList = async (params = {}) => {
    const { dateRange = [], ...formValues } = this.searchRef?.form?.getFieldsValue() || {};
    let { page: current = 1, page_size: pageSize = 10, status: currentStatus = undefined } = params;
    this.setState({
      currentStatus,
      // activeStatus: statusIndexToText[currentStatus],
      paginationProps: { ...this.state.paginationProps, current, pageSize }
    });

    const [apply_time_start, apply_time_end] = dateRange.map(item => moment(item).format('YYYY-MM-DD'));
    const { data: { data, code, msg } } = await inventoryReturnOrders({ apply_time_start, apply_time_end, ...formValues, ...params });
    if (+code === 0) {
      let { list = [], page, total } = data;
      let array = [];
      const orderList = list.map(item => {
        const { supplier_id, product = [] } = item;
        const total = product.reduce((acc, cur) => Number(acc) + Number(cur.number), 0) || [];
        const saleList = product.map(item => ({ ...item, supplier_id }));
        return {
          ...item,
          total,
          saleList,
          isExpand: saleList.length > showNumber
        };
      }) || [];

      this.setState({
        paginationProps: { ...this.state.paginationProps, current: Number(page), total: Number(total) },
        orderList,
        emptyStatus: (array.length <= 0 && params.status === undefined) ? 'returnOrder' : '',
        loading: false
      });
    } else {
      message.error(msg);
    }
  }

  toOrderDetail = (item, report = 0) => {
    this.props.history.push('/basic/user/order/detail/' + item.orderNo + '/' + report);
  }

  btnClicked = (item) => {
    const { buttonText, orderNo, orderStatus } = item;
    const status = orderStatus === 30 ? 40 : 50;
    send({
      url: '/ipp/order-purchase/status',
      method: 'POST',
      data: {
        id: orderNo,
        status
      }
    }).then(res => {
      if (res.data && res.data.code === 0) {
        message.success(buttonText + '成功');
        const { currentStatus, paginationProps: { current, pageSize } } = this.state;
        this.requestOrderList({ page: current, page_size: pageSize, status: currentStatus });
      } else {
        message.error(res.data.msg);
      }
    });
  }

  changeStatus = async (item) => {
    const { receiveInfo = [], orderNo: order_no, orderNo, orderStatus } = item;
    if (receiveInfo.length) {
      const { data: { msg, code } } = await send({ url: '/ipp/order-purchase/finish', method: 'POST', data: { order_no } });
      if (+code === 0) {
        message.success(msg);
        const { currentStatus, paginationProps: { current, pageSize } } = this.state;
        this.requestOrderList({ page: current, page_size: pageSize, status: currentStatus });
      } else {
        message.error(msg);
      }
    } else {
      const status = orderStatus === 30 ? 40 : 50;
      send({
        url: '/ipp/order-purchase/status',
        method: 'POST',
        data: {
          id: orderNo,
          status
        }
      }).then(res => {
        if (res.data && res.data.code === 0) {
          const title = `确定${item.orderStatus === 20 ? '取消' : `${item.receiveInfo.length ? '完结订单' : '收货'}`}`;
          message.success(title + '成功');
          const { currentStatus, paginationProps: { current, pageSize } } = this.state;
          this.requestOrderList({ page: current, page_size: pageSize, status: currentStatus });
        } else {
          message.error(res.data.msg);
        }
      });
    }
  }

  handleCancel = () => {
    this.setState({
      modalVisible: false
    });
  }

  handleOk = () => {
    const { currentOrder } = this.state;
    const { orderNo, orderStatus, buttonText } = currentOrder;
    const status = orderStatus === 30 ? 40 : 50;

    this.setState({
      modalVisible: false
    });

    send({
      url: '/ipp/order-purchase/status',
      method: 'POST',
      data: {
        id: orderNo,
        status
      }
    }).then(res => {
      if (res.data && res.data.code === 0) {
        message.success(buttonText + '成功');
        const { currentStatus, paginationProps: { current, pageSize } } = this.state;
        this.requestOrderList({ page: current, page_size: pageSize, status: currentStatus });
      } else {
        message.error(res.data.msg);
      }
    });
  }

  pageChanged = (page, pageSize) => {
    let { currentStatus } = this.state;
    this.requestOrderList({ page, page_size: pageSize, status: currentStatus });
  }

  toProductDetail = (product) => {
    const { supplier_id, sale_id, norms_id } = product;

    if (!norms_id || !supplier_id || !sale_id) {
      message.info('商品缺少spu_id或sale_id或supplier_id');
      return;
    }

    this.props.history.push('/basic/product/detail/' + sale_id + '/' + supplier_id + '/' + norms_id);
  }

  onHandlerSpot = (item) => {
    send({
      url: '/ipp/message/info',
      method: 'GET',
      params: {
        order_no: item.orderNo,
        buyer_id: item.purchaseId,
        supplier_id: item.supplierId,
      }
    }).then(res => {
      if (res.data && res.data.code === 0) {
        // 重新拉取列表
        const { currentStatus, paginationProps: { current, pageSize } } = this.state;
        this.requestOrderList({ page: current, page_size: pageSize, status: currentStatus });

        const { messageInfo } = this.state;

        let info = res.data.data;
        if (!info.msg_list) {
          info.msg_list = [];
        }
        let msgList = info.msg_list.map(item => ({
          buyerId: item.buyer_id,
          createTime: item.create_time,
          msgInfo: item.msg_info,
          role: item.role,
          supplierId: item.supplier_id
        }));
        info.msg_list = msgList;
        this.setState({
          messageInfo: {
            ...messageInfo,
            visible: true,
            ...info,
            title: item.supplier,
            list: info.msg_list,
            orderNo: item.orderNo,
            record: item
          },
        }, () => {
          const content = document.getElementsByClassName('message_scroll_content')[0];
          const scrollOffset = content.offsetHeight;
          const scrollOffsetHeight = content.scrollHeight;
          const diff = scrollOffsetHeight - scrollOffset;
          content.scrollTop = diff;
        });
      } else {
        message.error(res.data.msg);
      }
    });
  }

  expandFn = (item) => {
    const { isExpand, orderNo } = item;
    const { orderList = [] } = this.state;
    const newOrderList = orderList.map(item => orderNo === item.orderNo ? { ...item, isExpand: !isExpand } : item);
    this.setState({ orderList: newOrderList });
  }

  handleLogistics = (item) => {
    this.setState({
      logisticsVisible: true,
      orderStatus: item.status
    }, () => {
      this.getLogistics(item);
    });
  }

  getLogistics = (item) => {
    // purchaseGoodsLogistics({ order_no: item.orderNo, supplier_id: item.supplierId }).then(res => {
    //   if (res.data && res.data.code === 0) {
    //     const { data } = res.data;
    //     this.setState({
    //       logisticsData: data.length ? data : []
    //     });
    //   }
    // });
  }

  handleLogCancel = () => {
    this.setState({
      logisticsVisible: false
    });
  }

  perfectInformation = (item) => {
    this.props.history.push('/basic/user/order/information/' + item.orderNo);
  }

  render() {
    const { orderList, emptyStatus, loading, paginationProps } = this.state;
    const empty = (<div className="order-empty"><CpEmpty status={emptyStatus} history={this.props.history} /></div>);

    return (
      <div className="order-list-store">
        <div className="title">门店退货单</div>
        <div className="order-content">
          <SearchForm ref={el => this.searchRef = el} searchFn={this.searchFn} />
          {
            (orderList.length <= 0 && emptyStatus.length) ? empty : <RenderList
              formateList={orderList}
              btnClicked={this.btnClicked}
              changeStatus={this.changeStatus}
              toOrderDetail={this.toOrderDetail}
              handleLogistics={this.handleLogistics}
              perfectInformation={this.perfectInformation}
              expandFn={this.expandFn}
              onHandlerSpot={this.onHandlerSpot}
              // toProductDetail={this.toProductDetail}
            />
          }
        </div>
        {/* {orderList.length <= 0 && (<div className="status-empty-tip">当前状态下暂无门店退货单~</div>)} */}
        <div className="pagination">
          {loading || (orderList.length <= 0 && emptyStatus.length) ? null : <Pagination {...paginationProps} />}
        </div>
        <Modal
          open={this.state.modalVisible}
          cancelText="取消"
          okText="确定"
          onOk={() => { this.handleOk(); }}
          onCancel={() => { this.handleCancel(); }}>
          {'是否' + this.state.modalContent + '?'}
        </Modal>
      </div>
    );
  }
}
export default OrderList;